import { fetchUtils, Admin, Resource } from "react-admin";
import thaiMessages from "ra-language-thai";
import React from "react";
import UserIcon from "@material-ui/icons/People";
import NotiIcon from "@material-ui/icons/Notifications";
import MailIcon from "@material-ui/icons/Mail";
import AnnounceIcon from "@material-ui/icons/Announcement";
import RepairIcon from "@material-ui/icons/Build";
import FacilitiesIcon from "@material-ui/icons/AccountBalance";
import AreaInfoIcon from "@material-ui/icons/Info";
import HotlineIcon from "@material-ui/icons/Call";
import InterestingIcon from "@material-ui/icons/Star";
import RoomIcon from "@material-ui/icons/Home";
import ProjectIcon from "@material-ui/icons/LocalParking";
import ServiceIcon from "@material-ui/icons/Extension";
import FacilityBookingIcon from "@material-ui/icons/DateRange";
import PaymentIcon from "@material-ui/icons/Payment";
import PaymentInvoiceIcon from "@material-ui/icons/Attachment";
import AboutIcon from "@material-ui/icons/Face";
import AddIcon from "@material-ui/icons/NoteAdd";
import InvoiceLogIcon from "@material-ui/icons/AttachMoney";
import SendIcon from "@material-ui/icons/Send";
import SaleAgencyIcon from "@material-ui/icons/Business";
import GroupIcon from "@material-ui/icons/Group";

import appThaiMessage from "./locales/th";

import { AnnounceList, AnnounceCreate, AnnounceEdit, AnnounceShow } from "./components/announce/index";
import {
	authProvider,
	requesthandler,
	jsonServerProvider,
	checkPermission
} from "./services/";
import { HOST } from "./configs/index";
import {
	InterestingList,
	InterestingCreate,
	InterestingEdit,
	InterestingShow
} from "./components/interesting/index";
import {
	NearbyList,
	NearbyCreate,
	NearbyEdit,
	NearbyShow
} from "./components/nearby/index";
import {
	ProjectList,
	ProjectCreate,
	ProjectEdit
} from "./components/project/index";
import {
	RoomList,
	RoomCreate,
	RoomEdit,
	RoomShow
} from "./components/room/index";
import { UserList, UserEdit, UserCreate } from "./components/user/index";
import { RepairList, RepairEdit } from "./components/repair/index";
import { SosList, SosEdit } from "./components/sos/index";
import {
	AreainfoList,
	AreainfoEdit,
	AreainfoCreate
} from "./components/areainfo/index";
import {
	FacilitiesCreate,
	FacilitiesList,
	FacilitiesEdit
} from "./components/facilities/index";
import {
	MessageList,
	MessageCreate,
	MessageEdit
} from "./components/message/index";
import {
	HotlineList,
	HotlineCreate,
	HotlineEdit
} from "./components/hotline/index";
import {
	ServiceList,
	ServiceCreate,
	ServiceEdit
} from "./components/service/index";
import { FacilityBookingList, FacilityBookingEdit } from "./components/facilitybooking/index";
import { PaymentList } from "./components/payment/index";
import {
	PaymentInvoiceList,
	PaymentInvoiceEdit
} from "./components/paymentinvoice/index";
import { AboutList, AboutEdit } from "./components/about/index";
import { InvoiceLogList } from "./components/invoicelog/InvoiceLogList";
import { InvoiceList } from "./components/invoice/InvoiceList";
import {
	SaleAgencyList,
	SaleAgencyEdit,
	SaleAgencyCreate
} from "./components/saleagency/";
import { GroupList, GroupCreate, GroupEdit } from "./components/group";
import { BillList, BillCreate, BillEdit } from "./components/bill";
import { LineList, LineEdit, LineCreate } from "./components/line";
import BillType from "./components/billtype/index";
import Menu from "./components/Menu";
import Layout from "./components/Layout";

import { TypeList, TypeCreate, TypeEdit } from "./components/type/index";
import { Login } from "./components/auth/";
import sosNotiReducer from "./reducers/sosNotiReducer";
import repairNotiReducer from "./reducers/repairNotiReducer";
import facilityBookingNotiReducer from "./reducers/facilityBookingReducer";


const httpClient = (url, options = {}) => {
	if (!options.headers) {
		options.headers = new Headers({ Accept: "application/json" });
	}
	const token = localStorage.getItem("token");
	options.headers.set("Authorization", `Bearer ${token}`);
	return fetchUtils.fetchJson(url, options);
};

const dataProvider = jsonServerProvider(HOST, httpClient);
const dataRequest = requesthandler(dataProvider);

const messages = {
	th: { ...thaiMessages, ...appThaiMessage }
};
const i18nProvider = locale => messages[locale];

const App = () => {
	return (
		<Admin
			locale="th"
			i18nProvider={i18nProvider}
			menu={Menu}
			appLayout={Layout}
			customReducers={{
				sosNoti: sosNotiReducer,
				repairNoti: repairNotiReducer,
				facilityBookingNoti: facilityBookingNotiReducer
			}}
			authProvider={authProvider}
			loginPage={Login}
			dataProvider={dataRequest}
		>
			{permissions => [
				<Resource
					name="about"
					list={checkPermission(permissions, "about") && AboutList}
					edit={AboutEdit}
					icon={AboutIcon}
					options={{ label: "เกี่ยวกับ", type: "admin" }}
				/>,
				<Resource
					name="announce"
					list={checkPermission(permissions, "announce") && AnnounceList}
					create={AnnounceCreate}
					edit={AnnounceEdit}
					icon={AnnounceIcon}
					options={{ label: "ประกาศจากนิติ", type: "customer" }}
				/>,
				<Resource
					name="areainfo"
					list={checkPermission(permissions, "areainfo") && AreainfoList}
					create={AreainfoCreate}
					edit={AreainfoEdit}
					icon={AreaInfoIcon}
					options={{ label: "ข้อมูลพื้นที่", type: "presales" }}
				/>,
				<Resource
					name="bill"
					list={checkPermission(permissions, "bill") && BillList}
					create={BillCreate}
					edit={BillEdit}
					icon={PaymentIcon}
					options={{ label: "บิล", type: "customer" }}
				/>,
				<Resource
					name="billtype"
					{...BillType}
					options={{ label: "ประเภทบิล", type: "admin" }}
				/>,
				<Resource
					name="facilities"
					list={checkPermission(permissions, "facilities") && FacilitiesList}
					create={FacilitiesCreate}
					edit={FacilitiesEdit}
					icon={FacilitiesIcon}
					options={{ label: "สิ่งอำนวยความสะดวก", type: "customer" }}
				/>,
				<Resource
					name="facilitybooking"
					list={checkPermission(permissions, "facilitybooking") && FacilityBookingList}
					edit={FacilityBookingEdit}
					icon={FacilityBookingIcon}
					options={{ label: "จองสิ่งอำนวยความสะดวก", type: "customer" }}
				/>,
				<Resource
					name="group"
					list={checkPermission(permissions, "group") && GroupList}
					icon={GroupIcon}
					edit={GroupEdit}
					create={GroupCreate}
					options={{ label: "กลุ่ม", type: "customer" }}
				/>,
				<Resource
					name="hotline"
					list={checkPermission(permissions, "hotline") && HotlineList}
					create={HotlineCreate}
					edit={HotlineEdit}
					icon={HotlineIcon}
					options={{ label: "สายด่วน", type: "customer" }}
				/>,
				<Resource
					name="interesting"
					list={checkPermission(permissions, "interesting") && InterestingList}
					create={InterestingCreate}
					edit={InterestingEdit}
					icon={InterestingIcon}
					options={{ label: "ห้องที่น่าสนใจ", type: "presales" }}
				/>,
				<Resource
					name="invoice"
					list={checkPermission(permissions, "invoice") && InvoiceList}
					icon={InvoiceLogIcon}
					options={{ label: "ใบแจ้งหนี้", type: "admin" }}
				/>,
				<Resource
					name="invoicelog"
					list={checkPermission(permissions, "invoicelog") && InvoiceLogList}
					icon={InvoiceLogIcon}
					options={{ label: "รายการใบแจ้งหนี้", type: "admin" }}
				/>,
				<Resource
					name="line"
					list={checkPermission(permissions, "line") && LineList}
					edit={LineEdit}
					create={LineCreate}
					icon={SendIcon}
					options={{ label: "Line", type: "admin" }}
				/>,
				<Resource
					name="message"
					list={checkPermission(permissions, "message") && MessageList}
					create={MessageCreate}
					edit={MessageEdit}
					icon={MailIcon}
					options={{ label: "ข้อความ/ใบเสนอราคา", type: "customer" }}
				/>,
				<Resource
					name="paymentinvoice"
					list={
						checkPermission(permissions, "paymentinvoice") && PaymentInvoiceList
					}
					edit={PaymentInvoiceEdit}
					icon={PaymentInvoiceIcon}
					options={{ label: "ใบเสร็จการชำระเงิน", type: "customer" }}
				/>,
				<Resource
					name="project"
					list={checkPermission(permissions, "project") && ProjectList}
					create={ProjectCreate}
					edit={ProjectEdit}
					icon={ProjectIcon}
					options={{ label: "โครงการ", type: "admin" }}
				/>,
				<Resource
					name="repair"
					list={checkPermission(permissions, "repair") && RepairList}
					edit={RepairEdit}
					icon={RepairIcon}
					options={{ label: "ซ่อมแซม", type: "customer" }}
				/>,
				<Resource
					name="repairtype"
					list={checkPermission(permissions, "repairtype") && TypeList}
					create={TypeCreate}
					edit={TypeEdit}
					icon={AddIcon}
					options={{ label: "รายการซ่อม", type: "admin" }}
				/>,
				<Resource
					name="repairtypedata"
					list={checkPermission(permissions, "repairtypedata") && TypeList}
					create={TypeCreate}
					edit={TypeEdit}
					icon={AddIcon}
					options={{ label: "พื้นที่การซ่อม", type: "admin" }}
				/>,
				<Resource
					name="room"
					list={checkPermission(permissions, "room") && RoomList}
					create={RoomCreate}
					edit={RoomEdit}
					icon={RoomIcon}
					options={{ label: "ห้อง", type: "customer" }}
				/>,
				<Resource
					name="saleagency"
					list={checkPermission(permissions, "saleagency") && SaleAgencyList}
					create={SaleAgencyCreate}
					edit={SaleAgencyEdit}
					icon={SaleAgencyIcon}
					options={{ label: "ตัวแทนขาย", type: "admin" }}
				/>,
				<Resource
					name="service"
					list={checkPermission(permissions, "service") && ServiceList}
					create={ServiceCreate}
					edit={ServiceEdit}
					icon={ServiceIcon}
					options={{ label: "บริการ", type: "admin" }}
				/>,
				<Resource
					name="sos"
					list={checkPermission(permissions, "sos") && SosList}
					edit={SosEdit}
					icon={NotiIcon}
					options={{ label: "ฉุกเฉิน", type: "customer" }}
				/>,
				<Resource
					name="user"
					list={checkPermission(permissions, "user") && UserList}
					create={UserCreate}
					edit={UserEdit}
					icon={UserIcon}
					options={{ label: "ผู้ใช้งาน", type: "admin" }}
				/>
			]}
		</Admin>
	);
};

// checkPermission(permissions, 'nearby') ? <Resource name="nearby" options={{ label: 'Shop Nearby' }} list={NearbyList} create={NearbyCreate} edit={NearbyEdit} show={NearbyShow} /> : null,
{
	/* <Resource
          name="payment"
          list={checkPermission(permissions, "payment") && PaymentList}
          icon={PaymentIcon}
          options={{ label: "การชำระเงินรายเดือน", type: "customer" }}
        />, */
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js